





















































































import { Component, Vue } from 'vue-property-decorator';
import { Session } from '@/types/core';

import { curCoreClient, CoreClient } from '@/services/CoreClient';

import ErrorView from '@/components/VueError.vue';

@Component({
  components:{
    ErrorView,
  }
})
export default class Login extends Vue {
  
  // our model
  curView:'signIn'|'confirmSignIn' = 'confirmSignIn';
  email:string = '';
  password:string = '';

  authCode = '';
  pendingSession:Session = {} as Session;

  error:string = '';
  httpBusy:boolean = false;

  dirtyList:string[] = [];

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  mounted() {
    this.email = '';
    this.error = '';
    this.curView = "signIn";
    this.pendingSession = {} as Session;
  }

  async onDoLogin() {
    
    this.httpBusy = true;
    this.error = '';

    // we attempt a login
    const loginResp = await this.coreClient.doLogin(this.email, this.password !== '' ? this.password : undefined);

    this.httpBusy = false;

    if(loginResp.httpCode === 403) {
      this.error = `Wrong username and/or password`;
      return;
    }
    
    if(loginResp.errorMsg) {
      this.error = `Login error: ${loginResp.errorMsg}`;
      return;
    }

    // if this was a no pwd auth, let's show the confirm page
    if(this.password === '') {
      this.pendingSession = loginResp.session!;
      return this.curView = "confirmSignIn";
    }
      
    // if we had a password this was a normal login
    this.coreClient.setSession(loginResp.session!);

    // we redirect to /assets
    this.$router.push({name:'assets'});
  }

  resetLoginError() {
    this.error = '';
  }

  get canSignIn():boolean {
    return !this.httpBusy;
  }

  async onConfirmAuthCode() {
    
    this.httpBusy = true;
    this.error = '';

    // we attempt a login
    const loginResp = await this.coreClient.postAuthCode(this.pendingSession.token, parseInt(this.authCode));

    this.httpBusy = false;

    if(loginResp.httpCode === 403) {
      this.error = `Wrong auth code`;
      return;
    }
    
    if(loginResp.errorMsg) {
      this.error = `Auth code error: ${loginResp.errorMsg}`;
      return;
    }

    // if we had a password this was a normal login
    this.coreClient.setSession(this.pendingSession);

    // we redirect to /assets
    this.$router.push({name:'assets'});
  }

  onCancelAuthCode() {
    this.email = '';
    this.error = '';
    this.curView = "signIn";
    this.pendingSession = {} as Session;
  }

}
